import type { APIClient } from '@src/corelib/api';
import {
  type UseMutationOptions,
  useMutation as useTanstackMutation,
} from '@tanstack/react-query';

// import { queryClient } from '.';

export type BaseMutationOptions<TData, TError, TVariables, TContext> = Omit<
  UseMutationOptions<TData, TError, TVariables, TContext>,
  'mutationFn'
> & {
  mutateFn: (
    variables: TVariables & { apiClient: APIClient },
  ) => Promise<TData>;
};

function useBaseMutation<
  TData = unknown,
  TError = Error,
  TVariables = void,
  TContext = unknown,
>(
  client: APIClient,
  params: BaseMutationOptions<TData, TError, TVariables, TContext>,
) {
  const { mutateFn, ...restParams } = params;

  const mutateFnDefault = (variables: TVariables) => {
    return mutateFn({ ...variables, apiClient: client } as TVariables & {
      apiClient: APIClient;
    });
    // TODO: are we really need to pass query client here?
    //       Consider passing it to onSuccess for client data update
    // return mutateFn({ ...variables, apiClient: client, queryClient });
  };

  // TODO: Think about mutation key
  const mutation = useTanstackMutation({
    mutationFn: mutateFnDefault,
    ...restParams,
  });

  return mutation;
}

export default useBaseMutation;
